export default "__VITE_ASSET__17b4728d__"